import {
  TablePage,
  AddPage,
  EditPage,
  ResponsePage,
} from 'src/views/abi/entrysummary'
import pathMap from 'src/paths/pathMap'
import React from 'react'
import { StatementPage } from 'src/views/abi/StatementPage'

class AbiEntrySummaryRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_ENTRY_SUMMARY_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_ENTRY_SUMMARY_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ABI_ENTRY_SUMMARY_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ABI_ENTRY_SUMMARY_DETAILS_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_ENTRY_SUMMARY_RESPONSE_VIEW,
        component: ResponsePage
      },
      {
        exact: true,
        path: pathMap.ABI_STATEMENTS_VIEW,
        component: StatementPage
      }
    ]
  }
}

export default AbiEntrySummaryRoute
